import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setZoneActions,
  setRegionActions,
  setGeoLoactionStateAction,
  setaRoleChnage,
  settheAdvanceStateDatasHold,
  settheAdvanceEmployeeDatasparticular_countsHold,
  /// State management
  setadvanceAttendanceDashboard_state,
  setadvanceAttendanceDashboard_Region,
  setadvanceAttendanceDashboard_Zone,
  setadvanceAttendanceDashboard_FromDate,
  setadvanceAttendanceDashboard_TODate,
  settheAdvanceState_particularDatasHold,
  setthe_attendance_client_filter_dashboard,
  setClientBranchSearchAction,
} from "../../../Redux/Slice";
import { NavLink } from "react-router-dom";
import { DateRangePicker, Stack } from "rsuite";
import Select from "react-select";
import { useNavigate } from "react-router-dom";

import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import { differenceInDays } from "date-fns";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdvcanceState from "./AdvcanceState";
import AdvanceEmployee from "./AdvanceEmployee";
import ReactTable from "../../AppComponent/Table";
import AdvanceSeondState from "./AdvanceSeondState";
import useDebouncedEffect from "use-debounced-effect";
import { Attendance_summarycounts } from "./Attendance_summarycounts";

const Advance_hdfcattendance = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const RoleBased = useSelector((state) => state.SideBarFiles.Role);
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const state = useSelector((state) => state);
  const [nameList5, setOptions5] = useState([]);
  const [nameList4, setOptions4] = useState([]);

  const [datas, setData] = useState({
    zone: state.EmployeeVerificationsNeed.AdvancaAttendances_Zone?.value,
    state: state.EmployeeVerificationsNeed.AdvanceAttendance_State?.value,
    region: state.EmployeeVerificationsNeed.AdvanceAttendance_Region?.value,
  });
  const [multiselect, setMuliselect] = useState([
    state.EmployeeVerificationsNeed.AdvanceAttendance_State,
  ]);
  const [multiselect1, setMuliselect1] = useState([
    state.EmployeeVerificationsNeed.AdvanceAttendance_Region,
  ]);
  const [multiselect3, setMuliselect3] = useState([
    state.EmployeeVerificationsNeed.AdvancaAttendances_Zone,
  ]);
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [Name, setName] = useState({
    StateName: "All",
    ZoneName: "All",
  });
  var st = convert(
    state.EmployeeVerificationsNeed.FromDateTOAdvanceAttendancer,
  );
  var et = convert(state.EmployeeVerificationsNeed.ToDateTOAdvanceAttendancer);
  const getCurrentMonthStartAndEndDate = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();
    const startDatemon = `${currentYear}-${String(currentMonth + 1).padStart(
      2,
      "0",
    )}-${String(currentDate.getDate()).padStart(2, "0")}`;

    const endDatemon = `${currentYear}-${String(currentMonth + 1).padStart(
      2,
      "0",
    )}-${String(currentDate.getDate()).padStart(2, "0")}`;
    return {
      startDatemon,
      endDatemon,
    };
  };

  var { startDatemon, endDatemon } = getCurrentMonthStartAndEndDate();

  const [datefilter, setdatefilter] = useState({
    from_date: startDatemon,
    to_date: endDatemon,
    range: true,
  });

  const [range, setrange] = useState(
    state.EmployeeVerificationsNeed.FromDateTOAdvanceAttendancer == ""
      ? []
      : [st, et],
  );

  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    Clientsearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    Clientsearch: "",
  };

  const [SearchDebounance, setSearchDebounance] = useState(
    initialDebouanceSearch,
  );
  const [ClientId, setClientID] = useState({
    client:
      state.EmployeeVerificationsNeed.Attendance_dashboard_client_listed?.value,
  });

  ///---filter for white collar--------
  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "",
      label: "ALL",
    },
    {
      value: "1",
      label: "UDS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);
  const [EMpROleSelected, setEmpRoleSele] = useState(EmpRoles[0]);
  const [filterForWhite, setFilters] = useState({ white_collar: false });
  const [datestae, setdatest] = useState(false);
  const [Client, setClients] = useState();

  const [search, setSearch] = useState("");
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);

  const [dtpageindex_summary, setdtPageindex_summary] = useState(1);

  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      dispatch(setadvanceAttendanceDashboard_FromDate(range[0]));
      dispatch(setadvanceAttendanceDashboard_TODate(range[1]));
    }
  }, [range]);

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  const calculatePercentage = (value, total) => {
    return total > 0 ? (value / total) * 100 : 0;
  };

  const calculatePercentageOthers = (value, total) =>
    total > 0 ? (value / total) * 100 : 0;

  const attendanceData =
    state.AdvanceAttendance_counts_particularRecordsCall
      .AdvanceAttendance_particularRecords_countsData || {};

  const totalEmployees = attendanceData.total_user || 1; // Prevent division by zero
  const absentEmployees = attendanceData.absent_employee || 0;
  const weekOffEmployees = attendanceData.weekoff_employee || 0;

  // Sum of absent and week off employees
  const totalAbsentAndWeekOff = absentEmployees + weekOffEmployees;
  const [employeesearch, setempsearch] = useState("");

  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      const payload = {
        Counts: {
          state: datas.state,
          region: datas.region,
          zone: datas.zone,
          from_date: range[0],
          to_date: range[1],
          range: datefilter.range,
          white_collar: filterForWhite.white_collar,
          client_type:
            state.SideBarFiles.UserEmailID == "hdfcsales@uds.in"
              ? "HDFC Sales"
              : state.SideBarFiles.UserEmailID == "sbilife@uds.in"
                ? "SBI life"
                : state.SideBarFiles.UserEmailID == "arcolab@uds.in" &&
                  "STRIDES",
          client: ClientId?.client,
        },
        EmployeePayload: {
          state: datas.state,
          region: datas.region,
          zone: datas.zone,
          from_date: range[0],
          to_date: range[1],
          range: datefilter.range,
          white_collar: filterForWhite.white_collar,
          page: dtpageindex,
          page_size: "10",
          search: employeesearch,
          client_type:
            state.SideBarFiles.UserEmailID == "hdfcsales@uds.in"
              ? "HDFC Sales"
              : state.SideBarFiles.UserEmailID == "sbilife@uds.in"
                ? "SBI life"
                : state.SideBarFiles.UserEmailID == "arcolab@uds.in" &&
                  "STRIDES",
          client: ClientId?.client,
        },
      };
      dispatch(settheAdvanceEmployeeDatasparticular_countsHold(payload));
    }
  }, [datas, filterForWhite.white_collar, range, ClientId]);

  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      const payload = {
        state: datas.state,
        region: datas.region,
        zone: datas.zone,
        from_date: range[0],
        to_date: range[1],
        range: datefilter.range,
        white_collar: filterForWhite.white_collar,
        filtername:
          datas.state == "" && datas.region == "" && datas.zone == ""
            ? "all"
            : datas.state != "" && datas.region == "" && datas.zone == ""
              ? "state"
              : datas.state != "" && datas.region != "" && "region",

        client_type:
          state.SideBarFiles.UserEmailID == "hdfcsales@uds.in"
            ? "HDFC Sales"
            : state.SideBarFiles.UserEmailID == "sbilife@uds.in"
              ? "SBI life"
              : state.SideBarFiles.UserEmailID == "arcolab@uds.in" && "STRIDES",
        client: ClientId?.client,
      };
      dispatch(settheAdvanceState_particularDatasHold(payload));
    }
  }, [datas, filterForWhite.white_collar, range, ClientId]);

  // ----Handle----Date=-----Changes---

  const handlechangedate = (value) => {
    console.log(value, "asiduasud value");

    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
      setdatest(true);
      setdatefilter({
        ...datefilter,
        from_date: range[0],
        to_date: range[1],
        range: true,
      });
    }
  };

  const HandleEMprole = (e) => {
    if (e != null) {
      setEmpRoleSele(e);

      if (e.value == 1) {
        dispatch(setaRoleChnage(1));
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });
        setClients("");
      } else if (e.value == 2) {
        dispatch(setaRoleChnage(2)); ///Role based dispatch for the white_collar
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
      } else if (e.value == "") {
        setFilters({
          ...filterForWhite,
          white_collar: "",
        });
      }
    }
  };

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);

  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: 1,
      counts: 1,
      region_id: datas.region,
    };
    dispatch(setZoneActions(payloads));
  }, [datas.region, SearchedVal.zoneSearch]);

  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: 1,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: datas.state,
    };
    dispatch(setRegionActions(payloads));
  }, [datas.state, SearchedVal.regionSearch]);

  useEffect(() => {
    const Datas = [];

    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.GeoState.State.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.state_name.toUpperCase(),
        });
      });

      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];

    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name.toUpperCase(),
        });
      });

      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);

  useEffect(() => {
    if (state.BranchSearchpart.BranchSearch != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.BranchSearchpart.BranchSearch.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.client_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.BranchSearchpart.BranchSearch, SearchedVal?.Clientsearch]);

  useEffect(() => {
    // if(datas.state !="" && datas.region !="" && datas.zone !=""){
    const payload = {
      search: SearchedVal?.Clientsearch,
      page_size: 20,
      page: 1,
      data: datas,
    };
    setTimeout(() => {
      dispatch(setClientBranchSearchAction(payload));
    }, 400);
    // }
  }, [SearchedVal?.Clientsearch, datas]);

  const HandleInputBranch = (e) => {
    setSearchDebounance({
      ...SearchDebounance,
      Clientsearch: e,
    });
  };
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    setClientID({
      ...ClientId,
      client: "",
    });
    dispatch(
      setthe_attendance_client_filter_dashboard({ value: "", label: "ALL" }),
    );
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setMuliselect3([]);
      setData({
        ...datas,
        region: selectedVal.value,
        zone: "",
      });
      dispatch(setadvanceAttendanceDashboard_Region(selectedVal));

      dispatch(setadvanceAttendanceDashboard_Zone({ value: "", label: "ALL" }));
    }
    if (selectedVal == null) {
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...datas,
        region: "",
        zone: "",
      });
      dispatch(
        setadvanceAttendanceDashboard_Region({ value: "", label: "ALL" }),
      );

      dispatch(setadvanceAttendanceDashboard_Zone({ value: "", label: "ALL" }));
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    setClientID({
      ...ClientId,
      client: "",
    });
    dispatch(
      setthe_attendance_client_filter_dashboard({ value: "", label: "ALL" }),
    );
    //console.log(selectedVal ,"selected Values");
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setData({
        ...datas,
        zone: selectedVal.value,
      });

      setName({
        ...Name,
        ZoneName: selectedVal.label,
        StateName: Name.StateName,
      });

      dispatch(setadvanceAttendanceDashboard_Zone(selectedVal));
    }

    if (selectedVal == null) {
      setMuliselect3({ value: "", label: "ALL" });
      setName({
        ...Name,
        ZoneName: "",
        StateName: Name.StateName,
      });
      setData({
        ...datas,
        zone: "",
      });
      dispatch(setadvanceAttendanceDashboard_Zone({ value: "", label: "ALL" }));
    }
  };

  const handleSelectChange = (selectedVal) => {
    setClientID({
      ...ClientId,
      client: "",
    });
    dispatch(
      setthe_attendance_client_filter_dashboard({ value: "", label: "ALL" }),
    );
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect3({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });

      setData({
        ...datas,
        state: selectedVal.value,
        region: "",
        zone: "",
      });

      setName({
        ...Name,
        StateName: selectedVal.label,
        ZoneName: "",
      });

      dispatch(setadvanceAttendanceDashboard_state(selectedVal));
      dispatch(
        setadvanceAttendanceDashboard_Region({ value: "", label: "ALL" }),
      );

      dispatch(setadvanceAttendanceDashboard_Zone({ value: "", label: "ALL" }));
    }

    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(
        setadvanceAttendanceDashboard_state({ value: "", label: "ALL" }),
      );
      dispatch(
        setadvanceAttendanceDashboard_Region({ value: "", label: "ALL" }),
      );
      dispatch(setadvanceAttendanceDashboard_Zone({ value: "", label: "ALL" }));

      setData({
        ...datas,
        state: "",
        zone: "",
        region: "",
      });

      setName({
        ...Name,
        StateName: "",
        ZoneName: "",
      });
    }
  };

  const HandleClientBranches = (selectedVal) => {
    if (selectedVal != null) {
      setClientID({
        ...ClientId,
        client: selectedVal.value,
      });
      dispatch(setthe_attendance_client_filter_dashboard(selectedVal));
    } else if (selectedVal == null) {
      setClientID({
        ...ClientId,
        client: "",
      });
      dispatch(
        setthe_attendance_client_filter_dashboard({ value: "", label: "ALL" }),
      );
    }
  };

  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];

    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.zone_name.toUpperCase(),
        });
      });
      setOptions5(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);
  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearched({
          ...SearchedVal,
          stateSearch: SearchDebounance.stateSearch,
          regionSearch: SearchDebounance.regionSearch,
          zoneSearch: SearchDebounance.zoneSearch,
          Clientsearch: SearchDebounance.Clientsearch,
        });
      }
    },
    500,
    [SearchDebounance],
  );
  ///-----State----Input Changes
  const handleInputChange = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      stateSearch: Val,
    });
  };

  ///---Region-----------------
  const handleInputRegion = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      regionSearch: Val,
    });
  };
  ///----Zone---Name
  const handleInputZone = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      zoneSearch: Val,
    });
  };
  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
  ];
  const cleaningrange = () => {
    //setrange([gt,it]);
  };

  const openMe = () => {
    const rsAnimFade = document.querySelector(".rs-anim-fade");
    if (rsAnimFade) {
      rsAnimFade.style.setProperty("left", "887.34px", "important");
      rsAnimFade.style.setProperty("top", "186.109px", "important");
    }
  };

  const CloseDateRange = () => {
    const rsAnimFade = document.querySelector(".rs-anim-fade");
    if (rsAnimFade) {
      rsAnimFade.style.setProperty("display", "none", "important");
    }
  };

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            {RoleBased != undefined ? (
              <h2 class="user-name mb-0 WelcomeContent">{`Welcome ${capitalizeFirstLetter(
                RoleBased,
              )}! `}</h2>
            ) : null}
          </div>
        </div>

        <div
          className=" row Filters "
          style={{
            marginRight: "0px",
            marginLeft: "0px",
            padding: "0px 30px",
            zIndex: "89",
            marginTop: "14px ",
          }}
        >
          <div
            className="col-sm-2"
            style={{ marginTop: "-19px", zIndex: "99" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              State
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onChange={(e) => {
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
                console.log(e, "jjk9090");
              }}
              value={multiselect}
              labelledBy="Select"
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px" }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Region
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={true}
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px" }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Zone
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                handleZone(e);
              }}
              value={multiselect3}
              options={nameList5}
              isClearable={true}
              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}
            />
          </div>

          {/* <div
                        class=" field-div col-sm-2"
                        style={{ zIndex: "20", marginTop: "-19px" }}
                    >
                        <label
                            for="validationCustom02"
                            class="form-label FilterLabel"
                        >
                            Employee Designation
                        </label>

                        <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onChange={(e) => {
                                HandleEMprole(e);
                            }}
                            value={EMpROleSelected}
                            options={EmpRoles}
                            placeholder="search"
                        />
                    </div> */}

          <div className="col-sm-2 SelectedDate" style={{ marginTop: "-21px" }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px", width: "100%" }}
            >
              Select Date<span style={{ color: "red" }}>*</span>
            </label>

            <div className="datepicker_dash">
              <DateRangePicker
                defaultValue={
                  state.EmployeeVerificationsNeed
                    .FromDateTOAdvanceAttendancer == ""
                    ? []
                    : [
                        new Date(
                          state.EmployeeVerificationsNeed
                            .FromDateTOAdvanceAttendancer,
                        ),
                        new Date(
                          state.EmployeeVerificationsNeed
                            .ToDateTOAdvanceAttendancer,
                        ),
                      ]
                }
                onOpen={() => {
                  openMe();
                }}
                onClose={() => {
                  CloseDateRange();
                }}
                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                // style={{ width: 270, padding: 10 }}
                onClean={(e) => cleaningrange(e)}
                onChange={(e) => {
                  if (e != null && e.length === 2) {
                    const [startDate, endDate] = e;
                    const diffDays = differenceInDays(endDate, startDate);
                    if (startDate.getTime() === endDate.getTime()) {
                      // Since we are using inclusive range, difference should be 30 for 31 days
                      setrange([]);
                      e.forEach((newValue) => {
                        const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                        const localISOTime = new Date(newValue - tzoffset)
                          .toISOString()
                          .slice(0, -1);
                        handlechangedate(localISOTime);
                      });
                    } else {
                      toast.error(
                        "Please select the same date for both start and end.",
                        {
                          position: toast.POSITION.TOP_RIGHT,
                        },
                      );
                    }
                  }
                }}
              />
            </div>
          </div>
          <div
            className="col-sm-2"
            style={{ zIndex: "20", marginTop: "-19px" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Client
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // onSelect={(e) => {
              //   dispatch(SetTheDashboardClientList(e));
              // }}
              onChange={(e) => {
                setdtPageindex(1);
                HandleClientBranches(e);
              }}
              options={nameList4}
              labelledBy="Select"
              onInputChange={HandleInputBranch}
              isClearable={
                state.EmployeeVerificationsNeed
                  .Attendance_dashboard_client_listed?.label === "ALL"
                  ? false
                  : true
              }
              filterOption={() => true}
              value={
                state.EmployeeVerificationsNeed
                  .Attendance_dashboard_client_listed
              }
              isDisabled={EMpROleSelected?.value === "1" ? true : false}
            />
          </div>
        </div>
        <div
          className="row AdvanceattendanceReport"
          style={{ display: "flex", flexDirection: "row", padding: "0px 30px" }}
        >
          <div className="col-4" style={{ maxWidth: "24.999999%" }}>
            <div className="card AdvanceCards">
              <div className="card-body">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <h6>Total Employee</h6>

                  <span style={{ fontSize: "18px" }}>
                    {state.AdvanceAttendance_counts_particularRecordsCall
                      .AdvanceAttendance_particularRecords_countsData
                      ?.total_user || 0}
                  </span>
                </div>
                <div
                  className="progress"
                  style={{
                    width: "100%",
                    backgroundColor: "#e0e0e0",
                    borderRadius: "5px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                      width: `${100}%`,
                      backgroundColor: "blue",
                      height: "20px",
                      transition: "width 0.5s ease-in-out",
                      height: "7px",
                    }}
                    aria-valuenow={
                      state.AdvanceAttendance_counts_particularRecordsCall
                        .AdvanceAttendance_particularRecords_countsData
                        ?.total_user || 0
                    }
                    aria-valuemin="0"
                    aria-valuemax={
                      state.AdvanceAttendance_counts_particularRecordsCall
                        .AdvanceAttendance_particularRecords_countsData
                        ?.total_user || 0
                    }
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-4" style={{ maxWidth: "24.999999%" }}>
            <div className="card AdvanceCards">
              <div className="card-body">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <h6>Present</h6>

                  <span style={{ fontSize: "18px" }}>
                    {state.AdvanceAttendance_counts_particularRecordsCall
                      .AdvanceAttendance_particularRecords_countsData
                      ?.present_employee || 0}
                  </span>
                </div>
                <div
                  className="progress"
                  style={{
                    width: "100%",
                    backgroundColor: "#e0e0e0",
                    borderRadius: "5px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                      width: `${calculatePercentage(
                        state.AdvanceAttendance_counts_particularRecordsCall
                          .AdvanceAttendance_particularRecords_countsData
                          ?.present_employee || 0,
                        state.AdvanceAttendance_counts_particularRecordsCall
                          .AdvanceAttendance_particularRecords_countsData
                          ?.total_user || 1,
                      )}%`,
                      backgroundColor: "#4CAF50",
                      height: "20px",
                      transition: "width 0.5s ease-in-out",
                      height: "7px",
                    }}
                    aria-valuenow={
                      state.AdvanceAttendance_counts_particularRecordsCall
                        .AdvanceAttendance_particularRecords_countsData
                        ?.present_employee || 0
                    }
                    aria-valuemin="0"
                    aria-valuemax={
                      state.AdvanceAttendance_counts_particularRecordsCall
                        .AdvanceAttendance_particularRecords_countsData
                        ?.total_user || 0
                    }
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-4" style={{ maxWidth: "24.999999%" }}>
            <div className="card AdvanceCards">
              <div className="card-body">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <h6>Working</h6>

                  <span style={{ fontSize: "18px" }}>
                    {state.AdvanceAttendance_counts_particularRecordsCall
                      .AdvanceAttendance_particularRecords_countsData
                      ?.working_employee || 0}
                  </span>
                </div>
                <div
                  className="progress"
                  style={{
                    width: "100%",
                    backgroundColor: "#e0e0e0",
                    borderRadius: "5px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                      width: `${calculatePercentage(
                        state.AdvanceAttendance_counts_particularRecordsCall
                          .AdvanceAttendance_particularRecords_countsData
                          ?.working_employee || 0,
                        state.AdvanceAttendance_counts_particularRecordsCall
                          .AdvanceAttendance_particularRecords_countsData
                          ?.total_user || 1,
                      )}%`,
                      backgroundColor: "#ffd54f",
                      height: "20px",
                      transition: "width 0.5s ease-in-out",
                      height: "7px",
                    }}
                    aria-valuenow={
                      state.AdvanceAttendance_counts_particularRecordsCall
                        .AdvanceAttendance_particularRecords_countsData
                        ?.working_employee || 0
                    }
                    aria-valuemin="0"
                    aria-valuemax={
                      state.AdvanceAttendance_counts_particularRecordsCall
                        .AdvanceAttendance_particularRecords_countsData
                        ?.total_user || 0
                    }
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-4" style={{ maxWidth: "24.999999%" }}>
            <div className="card AdvanceCards">
              <div className="card-body">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <h6>Others</h6>

                  <span style={{ fontSize: "18px" }}>
                    {totalAbsentAndWeekOff || 0}
                  </span>
                </div>
                <div
                  className="progress"
                  style={{
                    width: "100%",
                    backgroundColor: "#e0e0e0",
                    borderRadius: "5px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                      width: `${calculatePercentageOthers(totalAbsentAndWeekOff, totalEmployees)}%`,

                      backgroundColor: "red",
                      height: "20px",
                      transition: "width 0.5s ease-in-out",
                      height: "7px",
                    }}
                    aria-valuenow={totalAbsentAndWeekOff}
                    aria-valuemin="0"
                    aria-valuemax={
                      state.AdvanceAttendance_counts_particularRecordsCall
                        .AdvanceAttendance_particularRecords_countsData
                        ?.total_user || 0
                    }
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="row AdvanceattendanceReport"
          style={{ display: "flex", flexDirection: "row", padding: "0px 30px" }}
        >
          <div className="col-6">
            <div
              className="card"
              style={{ borderRadius: "8px", border: "none" }}
            >
              <div className="card-body">
                <AdvcanceState datas={datas} />
              </div>
            </div>
          </div>
          <div className="col-6">
            <div
              className="card"
              style={{ borderRadius: "8px", border: "none" }}
            >
              <div className="card-body">
                <AdvanceSeondState datas={datas} />
              </div>
            </div>
          </div>
        </div>

        <div
          className="row AdvanceattendanceReport"
          style={{ display: "flex", flexDirection: "row", padding: "0px 43px" }}
        >
          <AdvanceEmployee
            dtpageindex={dtpageindex}
            setdtPageindex={setdtPageindex}
            employeesearch={employeesearch}
            setempsearch={setempsearch}
            range={range}
            datas={datas}
            datefilter={datefilter}
            filterForWhite={filterForWhite}
            client={ClientId?.client}
          />
        </div>

        <div
          className="row AdvanceattendanceReport"
          style={{ display: "flex", flexDirection: "row", padding: "0px 43px" }}
        >
          <Attendance_summarycounts
            dtpageindex={dtpageindex_summary}
            setdtPageindex={setdtPageindex_summary}
            employeesearch={employeesearch}
            setempsearch={setempsearch}
            range={range}
            datas={datas}
            datefilter={datefilter}
            filterForWhite={filterForWhite}
            client={ClientId?.client}
          />
        </div>
      </div>
    </>
  );
};

export default Advance_hdfcattendance;
